<template>
  <path d="M1,15l7-7L1,1" fill="none" stroke="#fddc03" stroke-width="1.1144" />
  <path d="M8,15l7-7L8,1" fill="none" stroke="#fddc03" stroke-width="1.1144" />
</template>
